/* eslint-disable @typescript-eslint/no-explicit-any */
import { ptBR } from 'date-fns/locale'
import dayjs from 'dayjs'
import { CalendarIcon } from 'lucide-react'
import type { Control } from 'react-hook-form'

import { cn } from '@/modules/shared/lib/utils'

import { Button } from './ui/button'
import { Calendar } from './ui/calendar'
import { FormControl, FormField, FormItem, FormLabel } from './ui/form'
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover'
type Props<T> = {
	label: string
	control: Control<any>
	name: Extract<keyof T, string>
	onChange?: (value: string) => void
	disabled?: boolean
}

export function DatePickerFormComponent<T>({
	control,
	name,
	label,
	disabled,
	onChange,
}: Props<T>) {
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-col flex-1">
					{label && <FormLabel className="font-normal">{label}</FormLabel>}
					<Popover>
						<PopoverTrigger asChild>
							<FormControl>
								<Button
									disabled={disabled}
									variant={'outline'}
									className={cn(
										' pl-3 text-left font-normal',
										!field.value && 'text-muted-foreground',
									)}
								>
									{field.value ? (
										dayjs(field.value).utc().format('DD/MM/YYYY')
									) : (
										<span>Selecione a {label}</span>
									)}
									<CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
								</Button>
							</FormControl>
						</PopoverTrigger>
						<PopoverContent className="w-auto p-0" align="start">
							<Calendar
								mode="single"
								locale={ptBR}
								selected={new Date(dayjs(field.value).utc().toISOString())}
								onSelect={(date) => {
									field.onChange(dayjs(date).utc().toISOString())
									onChange?.(dayjs(date).utc().toISOString())
								}}
							/>
						</PopoverContent>
					</Popover>
				</FormItem>
			)}
		/>
	)
}
